<div class="paneel">
	<div class="top">
		<h2 class="kop">Berichten</h2>
		<div class="tabbalk">
			<button
				type="button"
				class="tab"
				[class.actief]="activeTab() === GedeeldePaginaPersoonMode.INBOX"
				(click)="activeTab.set(GedeeldePaginaPersoonMode.INBOX)"
			>
				Inbox
				@if (ongelezenAantal() > 0) {
					<span class="teller">{{ ongelezenAantal() }}</span>
				}
			</button>
			<button
				type="button"
				class="tab"
				[class.actief]="activeTab() === GedeeldePaginaPersoonMode.OUTBOX"
				(click)="activeTab.set(GedeeldePaginaPersoonMode.OUTBOX)"
			>
				Verzonden
			</button>
		</div>
	</div>
	@if (userService.account(); as account) {
		@switch (activeTab()) {
			@case (GedeeldePaginaPersoonMode.INBOX) {
				<app-berichten-lijst [mode]="GedeeldePaginaPersoonMode.INBOX" [filter]="{ ontvanger: account }" (refresh)="herlaadTeller()" />
			}
			@case (GedeeldePaginaPersoonMode.OUTBOX) {
				<app-berichten-lijst [mode]="GedeeldePaginaPersoonMode.OUTBOX" [filter]="{ verzender: account }" (refresh)="herlaadTeller()" />
			}
		}
	}
</div>
